export * from './IconIpadFilled';
